import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import SafeIcon from '../../common/SafeIcon';

export default function Profile() {
  const { profile, user, signOut } = useAuth();

  return (
    <div className="p-4 pt-8 pb-24">
      <h1 className="text-2xl font-bold text-brand-navy mb-6">Profile</h1>
      
      <div className="flex items-center gap-4 mb-8">
        <div className="h-16 w-16 bg-brand-navy text-brand-gold rounded-full flex items-center justify-center text-2xl font-bold shadow-md">
          {profile?.full_name?.charAt(0) || 'U'}
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">{profile?.full_name || 'User'}</h2>
          <p className="text-gray-500 text-sm">{user?.email}</p>
          <p className="text-gray-500 text-sm">{profile?.phone}</p>
        </div>
      </div>

      <div className="space-y-4 mb-8">
        <Card className="flex items-center gap-4 py-4">
          <div className="bg-blue-50 p-2 rounded-lg text-brand-navy"><SafeIcon name="MapPin" /></div>
          <div className="flex-1 font-medium text-gray-700">Saved Addresses</div>
          <SafeIcon name="ChevronRight" className="text-gray-400" />
        </Card>
        
        <Card className="flex items-center gap-4 py-4">
          <div className="bg-blue-50 p-2 rounded-lg text-brand-navy"><SafeIcon name="CreditCard" /></div>
          <div className="flex-1 font-medium text-gray-700">Payment Methods</div>
          <SafeIcon name="ChevronRight" className="text-gray-400" />
        </Card>

        <Card className="flex items-center gap-4 py-4">
          <div className="bg-blue-50 p-2 rounded-lg text-brand-navy"><SafeIcon name="HelpCircle" /></div>
          <div className="flex-1 font-medium text-gray-700">Help & Support</div>
          <SafeIcon name="ChevronRight" className="text-gray-400" />
        </Card>
      </div>

      <Button onClick={signOut} variant="outline" className="w-full text-red-500 border-red-200 hover:bg-red-50 hover:border-red-500 hover:text-red-500">
        <SafeIcon name="LogOut" className="mr-2" /> Sign Out
      </Button>
    </div>
  );
}